import { LOCAL_STORAGE_KEY, getData } from '../state/localStorage';
import { AuthState } from './types';
import { canUserReport } from './utils';

const SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY = 'useNoCacheHeader';

export const setUseNoCacheHeader = (value: boolean): void => {
  sessionStorage.setItem(
    SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY,
    String(value),
  );
};

export const shouldUseNoCacheHeader = (): boolean => {
  // use this value to decide if we should use the X-No-Cache header in our api calls
  const cachedValue = sessionStorage.getItem(
    SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY,
  );

  if (cachedValue !== null) {
    return cachedValue === 'true';
  }

  const authData = getData<AuthState>(LOCAL_STORAGE_KEY.AUTH_STATE);
  const value = canUserReport(authData?.user || null);
  setUseNoCacheHeader(value);

  return value;
};
